'use strict';

var CmdDevice = require('./util/CmdDevice');
var log = require('../../../log/Log').channel('VivitekProjector');

function VivitekProjector(ipAddress, username, password, onConnectStatus, 
	onControlStatus, config) {
	this.firmwareVersion = 'unknown';
	this.power = false;
	this.volume = 0;
	this.volumeMute = true;
	this.videoInput = null;

	this.pollCycle = 0;

	CmdDevice.call(this, ipAddress, username, password, onConnectStatus,
		onControlStatus, config);
}

VivitekProjector.prototype = Object.create(CmdDevice.prototype);
VivitekProjector.prototype.constructor = VivitekProjector;

VivitekProjector.prototype.name = 'Vivitek Projector';
VivitekProjector.prototype.key = '-Kso51kZsxvMm8sDyW_7';
VivitekProjector.prototype.isAsync = false;
VivitekProjector.prototype.syncTimeout = 3000;
VivitekProjector.prototype.pingMs = 5000;
VivitekProjector.prototype.pollIntervalMs = 1000;

VivitekProjector.prototype.ports = [{
	port: 4999,
	verifySend: '~qP',
	verifyConnection: /On|Off/,
	verifyTimeoutMs: 3000,
	loginSkip: null,
	passwordPrompt: null,
	passwordPromptTimeoutMs: 0,
	passwordDefault: null,
	passwordSend: null,
	loginVerify: null,
	loginReject: null,
	loginVerifyTimeoutMs: 0
}];

VivitekProjector.prototype.simulationParams = {
	caps: {
		hasFirmwareVersion: true,
		hasPowerControl: true,
		hasRoomVolumeMute: true,
		hasVideoInputs: true,
		hasVideoSwitcher: true,
	},
	firmwareVersion: '???',
};

VivitekProjector.prototype.videoInputCodes = {
	'RGB': 'R',
	'RGB2': 'G',
	'DVI': 'D',
	'Video': 'V',
	'S-Video': 'S',
	'Component': 'Y',
	'HDMI': 'H',
	'Wireless': 'W',
};

VivitekProjector.prototype.commands = {};

VivitekProjector.prototype.commands.$powerPoll = {};
VivitekProjector.prototype.commands.$powerPoll.get = function() {
	this.sendCommand('$powerPoll', '~qP');
};
VivitekProjector.prototype.commands.$powerPoll.match = /(On|Off)/;
VivitekProjector.prototype.commands.$powerPoll.process = function(match) {
	var newPower = match[1] === 'On';

	if (this.power !== newPower) {
		this.power = newPower;
		this.broadcastStatus('power', this.power);
	}
};

VivitekProjector.prototype.commands.$videoInputPoll = {};
VivitekProjector.prototype.commands.$videoInputPoll.get = function() {
	this.sendCommand('$videoInputPoll', '~qS');
};
VivitekProjector.prototype.commands.$videoInputPoll.match = /(.+)/;
VivitekProjector.prototype.commands.$videoInputPoll.process = function(match) {
	this.setVideoInput(match[1], true);
};

VivitekProjector.prototype.commands.$volumePoll = {};
VivitekProjector.prototype.commands.$volumePoll.get = function() {
	this.sendCommand('$volumePoll', '~qM');
};
VivitekProjector.prototype.commands.$volumePoll.match = /(.+)/;
VivitekProjector.prototype.commands.$volumePoll.process = function(match) {
	var newVolume = 50 * parseInt(match[1]) / 100;

	if (this.volume !== newVolume) {
		this.volume = newVolume;
		this.broadcastStatus('volume', this.volume);
	}
};

VivitekProjector.prototype.commands.$volumeMutePoll = {};
VivitekProjector.prototype.commands.$volumeMutePoll.get = function() {
	this.sendCommand('$volumeMutePoll', '~qU');
};
VivitekProjector.prototype.commands.$volumeMutePoll.match = /(On|Off)/;
VivitekProjector.prototype.commands.$volumeMutePoll.process = function(match) {
	var newVolumeMute = match[1] === 'On';

	if (this.volumeMute !== newVolumeMute) {
		this.volumeMute = newVolumeMute;
		this.broadcastStatus('volumeMute', this.volumeMute);
	}
};

VivitekProjector.prototype.commands.firmwareVersion = {};
VivitekProjector.prototype.commands.firmwareVersion.get = function() {
	this.broadcastStatus('firmwareVersion', this.firmwareVersion);
};

VivitekProjector.prototype.commands.ping = {};
VivitekProjector.prototype.commands.ping.activeStates = [ 'controlling', 'controlFailed' ];
VivitekProjector.prototype.commands.ping.get = function() {
	this.sendCommand('ping', '~qV');
};
VivitekProjector.prototype.commands.ping.match = /.+/;
VivitekProjector.prototype.commands.ping.process = function(match) {
	if (this.firmwareVersion !== match[0]) {
		this.firmwareVersion = match[0];
		this.broadcastStatus('firmwareVersion', this.firmwareVersion);
	}
};

VivitekProjector.prototype.commands.power = {};
VivitekProjector.prototype.commands.power.get = function() {
	this.broadcastStatus('power', this.power);
};
VivitekProjector.prototype.commands.power.set = function(value) {
	this.sendCommand('power', value ? '~PN' : '~PF');

	if (value !== this.power) {
		this.power = value;
		this.broadcastStatus('power', this.power);
	}
};
VivitekProjector.prototype.commands.power.match = /On|Off/;

VivitekProjector.prototype.commands.videoInput = {};
VivitekProjector.prototype.commands.videoInput.get = function() {
	if (!this.config.hasOwnProperty('videoInputs')) {
		log.error(this + ': videoInput: get: no videoInputs in config: ' +
			JSON.stringify(this.config, null, 4));
		return;
	}

	this.broadcastStatus('videoInput', this.videoInput);
};
VivitekProjector.prototype.commands.videoInput.set = function(srcId) {
	if (!this.config.hasOwnProperty('videoInputs')) {
		log.error(this + ': videoInput: set: no videoInputs in config: ' +
			JSON.stringify(this.config, null, 4));
		return;
	}

	if (!this.config.videoInputs.hasOwnProperty(srcId)) {
		log.error(this + ': videoInput: set: srcId = ' + srcId +
			' not present in videoInputs for config = ' + 
			JSON.stringify(this.config, null, 4));
	}
	
	this.sendCommand('videoInput', '~S' + this.config.videoInputs[srcId].code);
	this.setVideoInput(srcId);
};
VivitekProjector.prototype.commands.videoInput.match = /.+/;

VivitekProjector.prototype.commands.volume = {};
VivitekProjector.prototype.commands.volume.get = function() {
	this.broadcastStatus('volume', this.volume);
};
VivitekProjector.prototype.commands.volume.set = function(value) {
	var newVolume = 100 * value / 50;

	this.sendCommand('volume', '~sM' + String.fromCharCode(newVolume));

	if (this.volume !== newVolume) {
		this.volume = newVolume;
		this.broadcastStatus('volume', this.volume);
	}
};
VivitekProjector.prototype.commands.volume = /.+/;

VivitekProjector.prototype.commands.volumeMute = {};
VivitekProjector.prototype.commands.volumeMute.get = function() {
	this.broadcastStatus('volumeMute', this.volumeMute);
};
VivitekProjector.prototype.commands.volumeMute.set = function(value) {
	this.sendCommand('volumeMute', '~sU' + (value ? 'N' : 'F'));

	if (this.volumeMute !== value) {
		this.volumeMute = value;
		this.broadcastStatus('volumeMute', this.volumeMute);
	}
};
VivitekProjector.prototype.commands.volumeMute.match = /(.+)/;
VivitekProjector.prototype.commands.volumeMute.process = function(match) {
	var newVolumeMute = match[1] === 'N';

	if (this.volumeMute !== newVolumeMute) {
		this.volumeMute = newVolumeMute;
		this.broadcastStatus('volumeMute', this.volumeMute);
	}
};

VivitekProjector.prototype.onPoll = function() {
	var pollParams = [ '$powerPoll', '$videoInputPoll', '$volumePoll', '$volumeMutePoll' ];

	if (this.pollCycle < 0 || this.pollCycle >= pollParams.length) {
		log.error(this + ': pollCycle ' + this.pollCycle + ' out of range');
		this.pollCycle = 0;
	}

	this.query(pollParams[this.pollCycle]);

	this.pollCycle++;
	if (this.pollCycle >= pollParams.length) this.pollCycle = 0;
};

VivitekProjector.prototype.setVideoInput = function(value, convert) {
	var newVideoInput = null;

	if (convert) {
		if (!this.videoInputCodes.hasOwnProperty(value)) {
			log.error(this + ': setVideoInput: unknown video input value: ' + value);
		} else if (!this.config.hasOwnProperty('videoInputs')) {
			log.error(this + ': setVideoInput: no videoInputs in config');
		} else {

			value = this.videoInputCodes[value];

			for (var srcId in this.config.videoInputs) {
				if (!this.config.videoInputs.hasOwnProperty(srcId)) continue;

				if (this.config.videoInputs[srcId].code === value) {
					newVideoInput = srcId;
					break;
				}
			}
		}
	} else {
		newVideoInput = value;
	}

	if (this.videoInput !== newVideoInput) {
		this.videoInput = newVideoInput;
		this.broadcastStatus('videoInput', this.videoInput);
	}
};

module.exports = VivitekProjector;